import { useCallback, useMemo } from 'react'

import { useAppDispatch } from '@app/hooks/useAppDispatch'
import { showModal, closeModal } from '@app/store/modals'

import { useAppSelector } from './useAppSelector'

export const useModal = (key: string) => {
  const modalState = useAppSelector((state) => state.modals[key])
  const dispatch = useAppDispatch()
  const open = useCallback(() => dispatch(showModal(key)), [key])
  const close = useCallback(() => dispatch(closeModal(key)), [key])
  const isOpen = modalState?.isOpen ?? false
  return useMemo(
    () => ({
      isOpen,
      open,
      close,
    }),
    [isOpen]
  )
}
